import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {ButtonGroup, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(ButtonGroup, {
        'children': (
            _$cc(Button, {
                'ev-click': this.showNotification,
                'children': '显示通知'
            })
        )
    });
};